const BusinessArea = {

    // FIELDS
    "name": "Pangalan",
    "short_name": "Maikling Pangalan",
    "code": "Kode",
    "description": "Paglalarawan",
    "address": "Adres",
    "gst_no": "GST Number",
    "city": "Lungsod",
    "postal_code": "Postal Code",
    "logo": "Logo",
    "cin_no": "CIN Number",
    "search": "Maghanap",

    // PAGE HEADER
    "business_area": "Sakop ng Negosyo",

    // ERROR
    "error_name": "Ilagay ang Pangalan",
    "error_short_name": "Ilagay ang Maikling Pangalan",
    "error_code": "Ilagay ang Kode",
    "error_description": "Ilagay ang Paglalarawan",
    "error_address": "Ilagay ang Adres",
    "error_gst_no": "Ilagay ang GST Number",
    "error_city": "Piliin ang Lungsod",
    "error_postal_code": "Ilagay ang Postal Code",
    "error_logo": "Pumili ng Logo",
    "error_logo_type": "Tanging JPG, JPEG, at PNG na mga file ang pinapayagan",
    "error_cin_no": "Ilagay ang CIN Number",

    // TABLE HEADER
    "table_name": "PANGALAN",
    "table_city": "LUNGSOD",
    "table_address": "ADRES",
    "table_gst": "GST",
}

export default BusinessArea;